<button
  mat-icon-button
  class="user-button"
  [matMenuTriggerFor]="menu"
  [class.impersonated]="impersonated$ | async"
>
  <mat-icon class="user-icon" fontSet="material-icons-outlined"
    >person</mat-icon
  >
  <mat-icon *ngIf="impersonated$ | async" class="secondary-icon"
    >priority_high</mat-icon
  >
</button>
<mat-menu #menu="matMenu" class="user-menu">
  <div *ngIf="user" class="user-menu__profil" fxLayout="row">
    <div class="monogram" fxLayoutAlign="center center">{{ monogram }}</div>
    <div fxLayout="column" fxLayoutAlign="center">
      <strong>{{ user.familyName }} {{ user.givenName }}</strong>
      <span>{{ user.email }}</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <ng-container
    *ngIf="
      (impersonated$ | async)
        ? true
        : !roles.includes('EASYLOT_ADMIN') &&
          !roles.includes('TELESALES') &&
          !roles.includes('IMPERSONATION')
    "
  >
    <a
      mat-menu-item
      [routerLink]="'/account/merchant'"
      class="sidenav-list-item"
    >
      <span>{{ "MENU.MERCHANT_BASIC_DATA" | translate }}</span>
    </a>
    <a mat-menu-item [routerLink]="'/account/users'" class="sidenav-list-item">
      <span>{{ "MENU.USERS" | translate }}</span>
    </a>
    <mat-divider></mat-divider>
  </ng-container>
  <ng-container *ngIf="impersonated$ | async">
    <button
      mat-menu-item
      class="sidenav-list-item impersonation-menu"
      (click)="removeImpersonation()"
    >
      <mat-icon class="primary-icon">person</mat-icon>
      <mat-icon class="secondary-icon">clear</mat-icon>
      <span>{{ "IMPERSONATION.EXIT" | translate }}</span>
    </button>
    <mat-divider></mat-divider>
  </ng-container>
  <ng-container *ngIf="availableProfiles.length > 1">
    <mat-divider *ngIf="(hasImpersonation$ | async) === false"></mat-divider>
    <button
      mat-menu-item
      [matMenuTriggerFor]="diagnosticSubmenu"
      class="sidenav-list-item"
    >
      <mat-icon class="me-3">tune</mat-icon>
      <span>{{ "DIAGNOSTIC.PROFILE_MENU.TITLE" | translate }}</span>
    </button>
    <mat-menu
      #diagnosticSubmenu="matMenu"
      (opened)="onDiagnosticSubmenuOpened()"
    >
      <button
        mat-menu-item
        disabled
        class="sidenav-list-item diagnostic-buffer-info"
      >
        <mat-icon class="me-3">memory</mat-icon>
        <span
          >{{ "DIAGNOSTIC.PROFILE_MENU.BUFFER_SIZE" | translate }}:
          {{ bufferSizeKb$ | async }} KB</span
        >
      </button>
      <mat-divider></mat-divider>
      <button
        *ngFor="let profile of availableProfiles"
        mat-menu-item
        (click)="onSelectProfile(profile)"
        class="sidenav-list-item"
      >
        <mat-icon *ngIf="activeProfile?.name === profile.name">check</mat-icon>
        <span [class.ms-4]="activeProfile?.name !== profile.name">{{
          "DIAGNOSTIC.PROFILE_MENU.PROFILE." + profile.name | translate
        }}</span>
      </button>
      <mat-divider *ngIf="hasDeepDebug"></mat-divider>
      <button
        *ngIf="hasDeepDebug"
        mat-menu-item
        (click)="openDeepDebugSettings()"
        class="sidenav-list-item"
      >
        <mat-icon class="me-3">settings</mat-icon>
        <span>{{
          "DIAGNOSTIC.DEEP_DEBUG_SETTINGS.MENU_ITEM" | translate
        }}</span>
      </button>
    </mat-menu>
  </ng-container>
  <a mat-menu-item [routerLink]="'/auth/logout'" class="sidenav-list-item">
    <mat-icon class="me-3">logout</mat-icon>
    <span>{{ "HEADER.BTN.LOGOUT" | translate }}</span>
  </a>
</mat-menu>
